import React from "react";

type Props = {
  className: string;
  fill: string;
};

export default function IconSeneca({ className, fill }: Props) {
  const pathProps = {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill
  };
  return (
    <svg
      width="416"
      height="400"
      viewBox="0 0 416 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* @ts-ignore */}
      <path
        {...pathProps}
        d="M207.897 161.735C205.775 161.735 203.654 159.694 203.123 157.143L194.108 47.449C191.456 18.8775 197.29 0 207.897 0C219.034 0 224.337 18.8775 221.686 47.449L212.67 157.143C212.139 160.204 210.018 161.735 207.897 161.735Z"
      />
      {/* @ts-ignore */}
      <path
        {...pathProps}
        d="M252.443 146.429C250.852 144.898 250.322 142.347 251.382 140.816L303.356 78.0613C316.615 61.7348 330.934 55.6123 338.359 63.2654C346.314 70.9184 339.95 84.1838 322.979 96.9389L257.747 146.939C256.686 148.469 254.034 147.959 252.443 146.429Z"
      />
      {/* @ts-ignore */}
      <path
        {...pathProps}
        d="M247.142 200C247.142 197.959 249.263 195.918 251.915 195.408L365.939 186.735C395.638 184.184 415.261 189.796 415.261 200C415.261 210.714 395.638 215.816 365.939 213.265L251.915 204.592C249.263 204.082 247.142 202.041 247.142 200Z"
      />
      {/* @ts-ignore */}
      <path
        {...pathProps}
        d="M252.443 240.816C254.034 239.286 256.685 238.775 258.276 239.796L323.509 289.796C340.48 302.551 346.844 316.327 338.889 323.469C330.934 331.122 317.145 325 303.886 308.673L251.912 245.918C250.321 244.898 250.852 242.347 252.443 240.816Z"
      />
      {/* @ts-ignore */}
      <path
        {...pathProps}
        d="M207.895 238.265C210.017 238.265 212.138 240.306 212.668 242.857L221.684 352.551C224.336 381.122 218.502 400 207.895 400C196.758 400 191.455 381.122 194.106 352.551L203.122 242.857C203.122 239.796 205.244 238.265 207.895 238.265Z"
      />
      {/* @ts-ignore */}
      <path
        {...pathProps}
        d="M154.331 240.816C155.922 242.347 156.452 244.898 155.392 246.429L103.418 309.184C90.1595 325.51 75.8403 331.633 68.4155 323.98C60.4603 316.327 66.8244 303.061 83.7954 290.306L149.028 240.306C150.088 238.776 152.74 239.286 154.331 240.816Z"
      />
      {/* @ts-ignore */}
      <path
        {...pathProps}
        d="M168.119 200C168.119 202.041 165.998 204.082 163.346 204.592L49.322 213.265C19.6227 215.816 0 210.204 0 200C0 189.286 19.6227 184.184 49.322 186.735L163.346 195.408C165.998 195.918 168.119 197.959 168.119 200Z"
      />
      {/* @ts-ignore */}
      <path
        {...pathProps}
        d="M154.332 146.429C152.741 147.959 150.089 148.469 148.498 147.449L83.2656 97.449C66.2946 84.6939 59.9305 70.9184 67.8857 63.7755C75.8408 56.1225 89.6298 62.2449 102.888 78.5714L154.862 141.327C156.453 142.347 155.923 144.898 154.332 146.429Z"
      />
    </svg>
  );
}
